const subjects = {
  math: {
    name: 'მათემატიკა',
    image:
      'https://cdn.pixabay.com/photo/2015/05/10/21/28/accounting-761599_960_720.jpg',
  },
  georgian: {
    name: 'ქართული',
    image:
      'https://images.pexels.com/photos/159711/books-bookstore-book-reading-159711.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  },
  english: {
    name: 'ინგლისური',
    image:
      'https://images.pexels.com/photos/267669/pexels-photo-267669.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  },
  history: {
    name: 'ისტორია',
    image:
      'https://images.pexels.com/photos/36006/renaissance-schallaburg-figures-facade.jpg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  },
  physics: {
    name: 'ფიზიკა',
    image:
      'https://images.pexels.com/photos/68173/flash-tesla-coil-experiment-faradayscher-cage-68173.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  },
  chemistry: {
    name: 'ქიმია',
    image:
      'https://images.pexels.com/photos/2280571/pexels-photo-2280571.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  },
  biology: {
    name: 'ბიოლოგია',
    image:
      'https://images.pexels.com/photos/920157/pexels-photo-920157.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  },
  law: {
    name: 'სამოქალაქო განათლება',
    image:
      'https://images.pexels.com/photos/6077326/pexels-photo-6077326.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  },
}

export default subjects
